import { useEffect, useCallback } from 'react';

export const useScript = ({
  scriptId = null,
  scriptUrl = null,
  src = null,
  onReady = () => {},
}) => {
  const handleOnLoad = useCallback(() => {
    onReady();
  }, [onReady]);

  useEffect(() => {
    const existingScript = document.getElementById(scriptUrl);

    if (!src) return;

    if (existingScript) {
      // Script already exists, call onReady immediately
      // Use setTimeout to ensure the script is fully loaded and available
      setTimeout(() => {
        onReady();
      }, 0);
      return;
    }

    // Script doesn't exist, create and load it
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = src;
    script.async = true;
    script.setAttribute('widgetId', 'b61f246c-75d7-4880-82fd-a98ed97fbf0d');
    script.setAttribute('chat', true);
    document.body.appendChild(script);
    script.onload = () => handleOnLoad();
  }, [src, handleOnLoad, scriptId, scriptUrl, onReady]);
};
